import * as React from "react";

const House: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.96 58.75" preserveAspectRatio="none">
            <path
                fill="currentColor"
                d="M46.47 14.18 30.98 0 15.49 14.18 0 28.37h8.52v30.38h14.66V43.56h15.6v15.19h14.66V28.37h8.52L46.47 14.18z"
            />
        </svg>
    );
};

export default React.memo(House);
